import { render, staticRenderFns } from "./AddPurchasesInvoicePage.vue?vue&type=template&id=6ffbfb45"
import script from "./AddPurchasesInvoicePage.vue?vue&type=script&lang=js"
export * from "./AddPurchasesInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports